import { render } from "./App.vue?vue&type=template&id=505d2366"
const script = {}

import "./App.vue?vue&type=style&index=0&id=505d2366&lang=less"

import exportComponent from "/home/workspace/ylproject-app-9350/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__